module.exports = __webpack_public_path__ + "static/media/icon-lamp-table.f9f736c6.svg";